import React from "react";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastify";
import { StaffingPeopleContext } from "./components/StaffingPeopleContext";
import PeopleRoster from "./components/PeopleRoster";

const optionShape = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
});

const StaffingPeopleApp = (props) => (
  <StaffingPeopleContext.Provider value={props}>
    <div className="od-themed" style={{ padding: 24 }}>
      <PeopleRoster />
    </div>
    <ToastContainer icon={false} />
  </StaffingPeopleContext.Provider>
);

StaffingPeopleApp.propTypes = {
  tabPaths: PropTypes.object.isRequired,
  permissions: PropTypes.shape({
    manageRoster: PropTypes.bool.isRequired,
    manageRates: PropTypes.bool.isRequired,
    readContactDetails: PropTypes.bool.isRequired,
    invite: PropTypes.bool.isRequired,
  }).isRequired,
  permissionScopes: PropTypes.shape({
    managePositionIds: PropTypes.arrayOf(PropTypes.number),
    ratePositionIds: PropTypes.arrayOf(PropTypes.number),
    importRoster: PropTypes.bool,
  }),
  filterOptions: PropTypes.shape({
    venues: PropTypes.arrayOf(optionShape).isRequired,
    positions: PropTypes.arrayOf(optionShape).isRequired,
    departments: PropTypes.arrayOf(optionShape).isRequired,
    statuses: PropTypes.arrayOf(optionShape).isRequired,
  }).isRequired,
  paths: PropTypes.shape({
    index: PropTypes.string.isRequired,
    create: PropTypes.string.isRequired,
    importPreview: PropTypes.string.isRequired,
    import: PropTypes.string.isRequired,
    departments: PropTypes.string.isRequired,
    invitations: PropTypes.string.isRequired,
    staffMember: PropTypes.string.isRequired,
    timeCards: PropTypes.string,
    timeCard: PropTypes.string,
  }).isRequired,
  importFields: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, label: PropTypes.string })).isRequired,
  importMaxBytes: PropTypes.number.isRequired,
};

export default StaffingPeopleApp;
